module.exports = __webpack_public_path__ + "lpg-masaze_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/ostatni/lpg-masaze_1_before_tn.jpg
// module id = 1516
// module chunks = 0